import type {
  InvoiceGenerationCategoryType,
  InvoiceGenerationTypes,
} from "@/redux/invoiceGeneration/invoiceGenrationTypes";

export const invoiceGenerationReducer = {
  resetInvoiceGenerationFetching: (state: InvoiceGenerationTypes) => {
    state.fetching = false;
    state.bulkUploadFetching = false;
  },
  resetInvoiceGenerationSuccess: (state: InvoiceGenerationTypes) => {
    state.success = null;
  },
  resetInvoiceGenerationOverDueEmailSuccess: (
    state: InvoiceGenerationTypes
  ) => {
    state.overDueEmailSuccess = null;
  },
  resetInvoiceGenerationOverDueEmailMessage: (
    state: InvoiceGenerationTypes
  ) => {
    state.overDueEmailMessage = null;
  },
  resetInvoiceGenerationError: (state: InvoiceGenerationTypes) => {
    state.error = null;
  },

  resetUpdateInvoiceGenerationSuccess: (state: InvoiceGenerationTypes) => {
    state.success = null;
  },
  resetUpdateInvoiceGenerationError: (state: InvoiceGenerationTypes) => {
    state.error = null;
  },
  resetMappedExpensesColumnList: (state: InvoiceGenerationTypes) => {
    state.mappedExpensesColumnsList = {} as InvoiceGenerationCategoryType;
  },
  resetMappedRevenueColumnList: (state: InvoiceGenerationTypes) => {
    state.mappedRevenueColumnsList = {} as InvoiceGenerationCategoryType;
  },
  resetMappedOtherColumnList: (state: InvoiceGenerationTypes) => {
    state.mappedOthersColumnList = {} as InvoiceGenerationCategoryType;
  },
  resetGetAllOtherInvoicesList: (state: InvoiceGenerationTypes) => {
    state.allOtherInvoicesList = [];
  },
  resetExpenseInvoicesList: (state: InvoiceGenerationTypes) => {
    state.allExpensesInvoicesList = [];
  },
  resetRevenueInvoicesList: (state: InvoiceGenerationTypes) => {
    state.allRevenueInvoicesList = [];
  },
  resetSingleInvoiceDetails: (state: InvoiceGenerationTypes) => {
    state.singleInvoiceDetails = {};
  },
  resetSingleOtherInvoiceDetails: (state: InvoiceGenerationTypes) => {
    state.singleOtherInvoiceDetails = {};
  },
  resetError: (state: InvoiceGenerationTypes) => {
    state.error = null;
    state.message = null;
  },
  resetSuccess: (state: InvoiceGenerationTypes) => {
    state.success = null;
    state.message = null;
  },
  resetUniqueTemplateNameMessage: (state: InvoiceGenerationTypes) => {
    state.success = null;
    state.uniqueTemplateNameMessage = null;
  },
  resetStatusCode: (state: InvoiceGenerationTypes) => {
    state.statusCode = null;
  },
  resetInvoicingFetching: (state: InvoiceGenerationTypes) => {
    state.fetching = false;
  },
  resetBulkUploadData: (state: any) => {
    state.bulkUploadData = {};
  },
  resetDuplicateEntry: (state: InvoiceGenerationTypes) => {
    state.isDuplicateEntry = null;
  },
  resetApprovalSuccess: (state: InvoiceGenerationTypes) => {
    state.approvalSuccess = null;
  },
  resetcommentsSuccess: (state: InvoiceGenerationTypes) => {
    state.commentsSuccess = null;
  },
  resetExpenseInvoicesTotal: (state: InvoiceGenerationTypes) => {
    state.expensesInvoicesTotal = "";
  },
  resetRevenueInvoicesTotal: (state: InvoiceGenerationTypes) => {
    state.revenueInvoicesTotal = "";
  },
  resetOtherInvoicesTotal: (state: InvoiceGenerationTypes) => {
    state.otherInvoicesTotal = "";
  },
  resetAllocationList: (state: InvoiceGenerationTypes) => {
    state.paymentPendingList = [];
  },
  resetAllAllocationList: (state: InvoiceGenerationTypes) => {
    state.allAllocationList = [];
  },
  resetLockOthersEntriesDate: (state: InvoiceGenerationTypes) => {
    state.lockOthersEntriesDate = null;
  },
  resetLockRevenueEntriesDate: (state: InvoiceGenerationTypes) => {
    state.lockRevenueEntriesDate = null;
  },
  resetLockExpensesEntriesDate: (state: InvoiceGenerationTypes) => {
    state.lockExpensesEntriesDate = null;
  },
  resetEinvoiceData: (state: InvoiceGenerationTypes) => {
    state.eInvoiceData = {};
  },
  resetEinvoiceReviewData: (state: InvoiceGenerationTypes) => {
    state.eInvoiceReviewData = {};
  },
  resetInvoiceNotesList: (state: InvoiceGenerationTypes) => {
    state.invoiceNotesList = [];
  },
  resetEinvoiceError: (state: InvoiceGenerationTypes) => {
    state.eInvoiceError = "";
  },
  resetEWayBillError: (state: InvoiceGenerationTypes) => {
    state.eWayBillError = "";
  },
  resetEWayBillUpdateError: (state: InvoiceGenerationTypes) => {
    state.eWayBillUpdateError = "";
  },
  resetSingleInvoiceData: (state: InvoiceGenerationTypes) => {
    state.customerSingleInvoiceData = {};
  },
  resetBomDataList: (state: InvoiceGenerationTypes) => {
    state.bomListData = { total_count: "", data: [] };
  },
  resetBomSavedTemplateListData: (state: InvoiceGenerationTypes) => {
    state.bomSavedTemplateListData = { total_count: "", data: [] };
  },
  resetSingleBomData: (state: InvoiceGenerationTypes) => {
    state.singleBomData = [];
  },
  resetSingleBomTemplateData: (state: InvoiceGenerationTypes) => {
    state.singleBomTemplateData = {};
  },
  resetInvoiceHistoryData: (state: InvoiceGenerationTypes) => {
    state.invoiceHistoryData = [];
  },
  resetBulkUploadHistoryData: (state: InvoiceGenerationTypes) => {
    state.bulkUploadHistoryData = [];
  },
  resetBulkUploadHistoryCount: (state: InvoiceGenerationTypes) => {
    state.bulkUploadCount = "";
  },
  resetOthersHistoryData: (state: InvoiceGenerationTypes) => {
    state.othersHistoryData = [];
  },
  resetOthersHistoryCount: (state: InvoiceGenerationTypes) => {
    state.othersHistoryCount = 0;
  },
  resetEWayBillReviewData: (state: InvoiceGenerationTypes) => {
    state.eWayBillReviewData = {};
  },
  resetPinCodeError: (state: InvoiceGenerationTypes) => {
    state.pinCodeError = "";
  },
  resetPinCodeDistanceCountData: (state: InvoiceGenerationTypes) => {
    state.pinCodeDistanceCountData = {};
  },
  resetLockBomEntriesDate: (state: InvoiceGenerationTypes) => {
    state.lockBOMEntriesDate = null;
  },

  resetIsClientColumnAssignedSuccess: (state: InvoiceGenerationTypes) => {
    state.isClientColumnAssignedSuccess = null;
  },
  resetIsClientColumnAssignedMessage: (state: InvoiceGenerationTypes) => {
    state.isClientColumnAssignedMessage = null;
  },
  resetClientOnboardingError: (state: InvoiceGenerationTypes) => {
    state.clientOnboardingError = null;
  },

  resetClientOnboardingSuccess: (state: InvoiceGenerationTypes) => {
    state.clientOnboardingSuccess = null;
  },

  resetClientOnboardingMessage: (state: InvoiceGenerationTypes) => {
    state.message = null;
  },

  resetClientOnboardingData: (state: InvoiceGenerationTypes) => {
    state.clientOnboardingData = null;
  },
  resetInvoiceGenerationEmailSuccess: (state: InvoiceGenerationTypes) => {
    state.invoiceGenerationEmailSuccess = 0;
  },
};
